import React, { useContext } from 'react';
import t from 'react-translate';
import { AngularServicesContext } from 'react-app';

// redux
import { useSelector } from 'react-redux';
import { getCurrentCourse, getFlatCourseAliases } from 'redux/selectors/course';

// hooks
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';

// components
import { config } from '../../../../../config/config.json';
import TopPanelActionButton from './top-panel-action-button';

const BackToCourseOutlineButton = () => {
  const params = useLecturePageParams();
  const { $state } = useContext(AngularServicesContext);
  const currentCourse = useSelector(state => getCurrentCourse(state));
  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));

  /** Navigate to the course outline (course home page) in edit mode */
  const outlineHref = () => $state.go(
    currentCourse.isProgram ? 'program-timelines-edit' : 'course-home-edit',
    { catalogId: params.catalogId },
  );

  return (
    <React.Fragment>
      <TopPanelActionButton
        icon='home'
        tooltipText={t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.BACK_TO_OUTLINE(courseAliases)}
        onClick={outlineHref}
        useDefaultStyle={false}
        className='p-4 mr-2'
        dataQa={config.pendo.lectureEdit.editMenuTopPanel.backToCourseOutlineHome}
        ariaLabel={t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.BACK_TO_OUTLINE(courseAliases)}
      />
    </React.Fragment>
  );
};

export default BackToCourseOutlineButton;
